var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#003393",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#003393",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#003393",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#003393",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.1c3a1865ac13bc84158472763274aa88.svg";
export { ForwardRef as ReactComponent };